import {createTheme} from "@mui/material";

export default createTheme({
    palette : {
        primary: {
            main: "#FF9200"
        },
        background: {
            default: "#000000"
        },
        shape:{
            borderRadius: 6
        
        }
    },
    typography: {
        fontFamily: "Montserrat",
        
        h4 : {
            color : "#FF9200",
            fontSize: 41,
        },
        body1 : {
            color : "#FF9200",
            fontSize: 19,
        },
    },
    NativeSelect: {
        
    }
})